import { IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { AxiosRequest, ImgURLSRC } from "../../Url";
import { getIconsAsync, getStyleWindow } from "../../MainPage/Tools/Tools";
import { TokenSubData } from "../../TokenProcessing/TokenProcessing";
import TextAreaWithButtons from "../../MainPage/Module/Dialogs/Components/TextAreaWithButtons";
import { EditColumnField } from "../../MainPage/Tools/Requests";
import React from "react";
import { smetaModals } from "../../MainPage/Tools/modalManager";
import DialogCalendar from "../../MainPage/Module/Dialogs/DialogCalendar";
import smetaAxios from "../../SmetaAxios";
import { Prefixes } from "../../MainPage/Tools/ProjectX";
import { EditData, EditorProps } from "../Editor";
import { EventDataInfo } from "../../MainPage/Tools/VirtualList/VirtualList";

export interface SubdataProps {
  FieldName?: string;
  Current?: string;
  Value?: string;
  ObjRef?: string | number;
  ObjType?: string;
  Module?: string;
  data?: any;
  Path?: string;
  GroupID?: string;
  Name?: string;
  record?: any;
  editParam?: string;
  addInfo?: any;
  MultiSel?: boolean;
  Selection?: string;
  input?: React.RefObject<null | HTMLInputElement>;
  from?: "grid" | "Forms" | "ModalProgress";
  onClose?: () => void | Promise<void>;
  func?: (data: any) => void | Promise<void>;
  onEdit?: (data: EditorProps & EditData) => void | Promise<void>;
  setValue?: (data: { label: string; id?: string }) => void;
  setInputValue?: (label: string) => void;
  setSelection?: (data?: any) => void | Promise<void>;
}

// запрос для данных модального окна
const getDialogParam = (
  module: string,
  objType: string,
  objref: string | number,
  multisel?: boolean,
): Promise<Record<string, any>> => {
  let param = new Map(),
    json;
  param.set("prefix", module);
  param.set("comand", "GetDialogParams");
  param.set("ObjType", objType);
  param.set("ObjRef", objref);
  if (multisel) param.set("MultiSel", "1");
  return AxiosRequest(true, param);
};
// Функция для открытия модального окна
function openModalWindow(props: EditorProps & ModalButtonProps, json: any, subData: TokenSubData) {
  if (props.onEditButtonClick) {
    props.onEditButtonClick({
      ...props,
      events: props.onEvents,
      objref: subData.props?.ObjRef || props.objref,
      json: json,
      subData: subData,
      setValue: subData.props?.setValue,
      setInputValue: subData.props?.setInputValue,
    });
  }
}

interface ModalButtonProps {
  buttonImage?: number;
  disabled?: boolean;
  refButton: React.RefObject<null | HTMLButtonElement>;
  input: React.RefObject<null | HTMLInputElement>;
  id?: string;
  valueEditor?: EventDataInfo;
  EditStyle_Ellipsis: boolean;
  EditStyle_Calendar: boolean;
  inputValue: string;
  closeList: () => void;
  setSelection: React.Dispatch<React.SetStateAction<string | undefined>>;
  setValue: React.Dispatch<React.SetStateAction<EventDataInfo>>;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function ModalButton(props: ModalButtonProps & EditorProps) {
  const {
    EditStyle_Calendar,
    EditStyle_Ellipsis,
    closeList,
    refButton,
    addInfo,
    buttonImage,
    current,
    datatype,
    disabled,
    fieldname,
    groupid,
    id,
    name,
    objref,
    path,
    data,
    record,
    selection,
    type,
    valueEditor,
    from,
    editParam,
    multisel,
    settings,
    documentGrid,
    docProps,
    inputValue,
    title,
    input,
    onEdit,
    setSelection,
    setValue,
    setInputValue,
    func,
  } = props;
  const [icon, setIcon] = React.useState<string>();

  React.useEffect(() => {
    if (buttonImage) {
      getIconsAsync(buttonImage).then((res) => {
        setIcon(ImgURLSRC(res));
      });
    }
  }, []);

  return (
    <IconButton
      disabled={disabled}
      ref={refButton}
      key={`modal-button_${id}`}
      className="modal-button"
      style={{
        width: "20px !important",
        height: "100%",
        borderRadius: "0px",
        padding: "0",
        display: EditStyle_Ellipsis && !EditStyle_Calendar ? "flex" : "none",
      }}
      type="button"
      onClick={async () => {
        if (disabled) return;
        closeList();
        const subData: TokenSubData = {
          props: {
            FieldName: fieldname,
            Current: current,
            Value: valueEditor?.label,
            ObjRef: valueEditor?.id || "0",
            ObjType: datatype,
            Module: type,
            data: data,
            Path: path,
            GroupID: groupid,
            Name: name,
            record: record,
            editParam: editParam,
            addInfo: { ...addInfo, editButtonClick: true },
            MultiSel: Boolean(multisel),
            Selection: selection,
            input: input,
            from: from,
            func: func,
            onEdit: onEdit,
            setValue: setValue,
            setInputValue: setInputValue,
            setSelection: setSelection,
          },
          func: func,
          from: from,
        };
        let json;
        if (settings?.onEdit) {
          if (!documentGrid) {
            const params = {
              ProgID: settings.onEdit,
              Value: objref,
              WSM: "1",
            };
            const config = {
              prefix: Prefixes.progs,
              method: "GET",
              url: "EditParamProperty",
              params,
            };

            json = await smetaAxios(config);
            if (subData.props) {
              subData.props.addInfo.needPost = true;
              subData.props.addInfo.checkObjRefBeforePost = true;
            }
          } else {
            if (!docProps) return;
            json = await EditColumnField({
              Module: "documents",
              DocCfgID: docProps.DocCfgID,
              SectionID: docProps.SectionID,
              ID: docProps.ID,
              DocID: docProps.DocID,
              MasterID: docProps.MasterID,
              Reference: docProps.Reference,
            });
          }
          openModalWindow(props, json, {
            ...subData,
            from: "grid",
            func: addInfo.ModalButtonCallBack,
          });
          return;
        }
        if (addInfo?.onEditButtonClick) {
          addInfo.onEditButtonClick(subData);
          return;
        }
        if (datatype === "0") {
          if (subData.props) subData.props.editParam = "1";
          openModalWindow(props, json, subData);
          return;
        }

        if (subData.props && subData.props.editParam === undefined && Number(datatype) > 0 && Number(datatype) <= 12) {
          if (datatype === "4") {
            smetaModals.open(
              <DialogCalendar
                props={{
                  onEdit: onEdit,
                  ...props,
                  inputValue: inputValue,
                }}
              />,
              {
                Title: "Календарь",
                style: getStyleWindow(),
                hiddenButton: true,
                blockMaximize: true,
              },
            );
            return;
          }
          smetaModals.open(
            <TextAreaWithButtons
              props={{
                ...props,
                setValue: props.setValue,
                setInputValue: props.setInputValue,
                Title: "",
                Value: props.inputValue,
              }}
            />,
            {
              Title: props?.record?.dataset?.name || title || "Текст параметра",
              style: getStyleWindow(),
              hiddenButton: true,
            },
          );
          return;
        }

        if (props.editParam === undefined && (Number(datatype) < 7 || Number(datatype) > 12)) {
          json = await getDialogParam(type || "", datatype || "", valueEditor?.id || "0", multisel);
          if (json.ObjType && subData.props) subData.props.ObjType = json.ObjType;
          if (json.ObjRef && subData.props) subData.props.ObjRef = json.ObjRef;

          if (!json.Break) json.Break = "";
          if (!json.Token) json.Token = "HandleTable";
        }
        openModalWindow(props, json, subData);
      }}
    >
      {props.buttonImage ? (
        <img style={{ maxHeight: "20px" }} src={icon} />
      ) : (
        <MoreHorizIcon style={{ maxHeight: "20px" }} />
      )}
    </IconButton>
  );
}
